uniform float u_time;
varying vec2 vUv;
varying vec2 vUv1;
varying vec4 vPosition;

uniform sampler2D texture1;
uniform sampler2D texture2;
uniform vec2 u_pixels;
uniform vec2 u_uvRate1;

void main() 
{
    vUv = uv;
    vec2 _uv = uv - 0.5;
    vUv1 = _uv;
    vUv1 *= u_uvRate1.xy;

    vUv1 += 0.5;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}